import { MutationTree } from 'vuex';
import { IAuthState } from '@/store/interfaces';

export const mutations: MutationTree<IAuthState> = {
  SET_ATOKEN_EXP_DATE(state, expDate) {
    state.accessTokenExpDate = expDate;
  },
};
